import { useState, useMemo, useEffect, useCallback } from "react";
import styles from "./SupplierModal.module.css";
import { API_URL } from '../../../config/api';

const SupplierModal = ({ isOpen, onClose, onSelect }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const suppliersPerPage = 5;

  const fetchSuppliers = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        `${API_URL}/api/contractors?type=supplier`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      console.log("📦 Получено с API (suppliers):", data);

      if (Array.isArray(data?.data)) {
        setSuppliers(data.data);
      } else {
        console.warn("⚠️ Ответ API без data:", data);
        setSuppliers([]);
      }
    } catch (err) {
      console.error("❌ Ошибка загрузки поставщиков:", err);
      setSuppliers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isOpen) fetchSuppliers();
  }, [isOpen, fetchSuppliers]);

  const filtered = useMemo(() => {
    return suppliers.filter((s) =>
      s.name?.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, suppliers]);

  const totalPages = Math.ceil(filtered.length / suppliersPerPage);

  const currentSuppliers = filtered.slice(
    (page - 1) * suppliersPerPage,
    page * suppliersPerPage
  );

  const handleSelect = (supplier) => {
    onSelect(supplier);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Выберите поставщика</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.tabButtons}>
          <button className={styles.activeTab}>Список поставщиков</button>
          <button className={styles.inactiveTab}>Новый поставщик</button>
        </div>

        <input
          type="text"
          placeholder="Поиск"
          className={styles.search}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {loading && <p className={styles.loadingText}>Загрузка...</p>}

        {!loading && (
          <div className={styles.list}>
            {currentSuppliers.map((supplier) => (
              <button
                key={supplier.id}
                className={styles.listItem}
                onClick={() => handleSelect(supplier)}
              >
                {supplier.name}
              </button>
            ))}

            {currentSuppliers.length === 0 && (
              <p className={styles.noResults}>Ничего не найдено</p>
            )}
          </div>
        )}

        {filtered.length > 5 && (
          <div className={styles.pagination}>
            <button disabled={page === 1} onClick={() => setPage(page - 1)}>
              &lt;
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={page === i + 1 ? styles.activePage : ""}
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              &gt;
            </button>
          </div>
        )}

        <button className={styles.selectButton} onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>
  );
};

export default SupplierModal;
